<template>
  <PieChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    :field-label="fieldLabel"
    class="make-a-copy"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import PieChart from '@/components/cards/models/PieChart';
import channelModel from '@/mixins/channel-model';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { OPERATION } from '@/services/charts-service';
import { DATA_TYPE } from '@/store/modules/cards/constants';
import sacListeningModel from '@/mixins/sac-listening-model';
import { primaryAndSecondaryChannels } from '@/utils/channels';

export default {
  name: 'BaseChannelPieChartOwnedEarned',
  components: {
    PieChart,
  },
  mixins: [
    channelModel,
    sacListeningModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    operation: {
      type: String,
      default: OPERATION.COUNT,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
    };
  },
  computed: {
    fieldLabel() {
      return this.$t('components.BaseChannelPieChartOwnedEarned.label.filter');
    },
    series() {
      const _rawSeries = Array.from(this.rawSeries)
        .filter(rawSerie => {
          return 'name' in rawSerie;
        });
      return _rawSeries.map(({ name, data }) => {
        const channelObj = this.getChannelColorNameAndIcon(name);
        return {
          name: channelObj.name,
          color: channelObj.color,
          y: data[0],
        };
      });
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSacListeningWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      const promisses = [
        this.createRequisitions(DATA_TYPE.LISTENING),
        this.createRequisitions(DATA_TYPE.SAC),
      ];

      Promise.all(
        promisses
      ).then(([responseListening, responseSac]) => {
        const agregatedResponse = this.getAgregatedResponse(responseListening.channels, responseSac.channels);
        this.rawSeries = agregatedResponse.sort((listeningValue, sacValue) => {
          return listeningValue.data[0] > sacValue.data[0]
            ? -1 : listeningValue.data[0] < sacValue.data[0]
              ? 1 : 0;
        });
        this.requestStatus = 'success';

        if (options?.silentRefresh) {
          EventBus.$emit('updated', { itemId: this.itemId });
        }
      }).catch(() => {
        this.requestStatus = 'error';
      });
    },
    getAgregatedResponse(responseListening, responseSac) {
      const responseArray = [];
      Object.keys(responseListening).forEach((channel) => {
        const obj = { name: channel, data: [] };

        if (responseSac.hasOwnProperty(channel)) {
          obj.data = [responseListening[channel] + responseSac[channel]];
        } else {
          obj.data = [responseListening[channel]];
        }

        responseArray.push(obj);
      });

      Object.keys(responseSac).forEach((channel) => {
        const existsInListening = responseArray.find(element => element.name === channel);
        if (!existsInListening) {
          const obj = { name: channel, data: [responseSac[channel]] };
          responseArray.push(obj);
        }
      });
      const response = this.agregateChannels(responseArray);

      return response;
    },
    agregateChannels(channels) {
      const agregatedChannels = [];
      primaryAndSecondaryChannels.map((channel) => {
        const result = { name: channel.primary, data: [] };
        for (let i = 0; i < channels.length; i++) {
          if (channel.secondary.includes(channels[i].name)) {
            if (result.data.length === 0) {
              result.data = [channels[i].data[0]];
            } else {
              result.data = [result.data[0] += channels[i].data[0]];
            }
          }
        }
        if (result.data.length > 0) {
          agregatedChannels.push(result);
        }
        return result;
      });
      return agregatedChannels;
    },
    createRequisitions(dataType) {
      return this.getSacListeningWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringOverview',
        filterType: dataType,
      });
    },
  },
};
</script>
